// export const CONFIRMED_GET_RECEPTIONISTS = "CONFIRMED_GET_RECEPTIONISTS";
// export const CONFIRMED_CREATE_RECEPTIONIST_ACTION =
//   "CONFIRMED_CREATE_RECEPTIONIST_ACTION";
// export const CONFIRMED_DELETE_RECEPTIONIST_ACTION =
//   "CONFIRMED_DELETE_RECEPTIONIST_ACTION";
// export const CONFIRMED_EDIT_RECEPTIONIST_ACTION =
//   "CONFIRMED_EDIT_RECEPTIONIST_ACTION";
// export const CONFIRMED_MARK_PATIENT_CURRENT = "CONFIRMED_MARK_PATIENT_CURRENT";
// export const CONFIRMED_ADD_VITALS_ACTION = "CONFIRMED_ADD_VITALS_ACTION";
// export const CONFIRMED_COLLECT_PAYMENT_ACTION =
//   "CONFIRMED_COLLECT_PAYMENT_ACTION";
// export const CONFIRMED_UPCOMING_APPOINTMENT = "CONFIRMED_UPCOMING_APPOINTMENT";
// export const CONFIRMED_GET_AVAILABLE_SLOTS = "CONFIRMED_GET_AVAILABLE_SLOTS";
// export const CONFIRMED_RESCHEDULE_APPOINTMENT =
//   "CONFIRMED_RESCHEDULE_APPOINTMENT";
// export const CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT =
//   "CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT";
//   export const CONFIRMED_SEND_FORM_LINK= "CONFIRMED_SEND_FORM_LINK";
// export const CONFIRMED_PAUSE_DOCTOR_QUEUE = "CONFIRMED_PAUSE_DOCTOR_QUEUE"
// export const CONFIRMED_MARK_PATIENT_EMERGENCY = "CONFIRMED_MARK_PATIENT_EMERGENCY"
export const CONFIRMED_CREATE_RECEPTIONIST_ACTION =
  "CONFIRMED_CREATE_RECEPTIONIST_ACTION";
export const CONFIRMED_MARK_PATIENT_CURRENT = "CONFIRMED_MARK_PATIENT_CURRENT";
export const CONFIRMED_EDIT_RECEPTIONIST_ACTION =
  "CONFIRMED_EDIT_RECEPTIONIST_ACTION";
export const CONFIRMED_GET_RECEPTIONISTS = "CONFIRMED_GET_RECEPTIONISTS";
export const CONFIRMED_DELETE_RECEPTIONIST_ACTION =
  "CONFIRMED_DELETE_RECEPTIONIST_ACTION";
export const CONFIRMED_ADD_VITALS_ACTION = "CONFIRMED_ADD_VITALS_ACTION";
export const CONFIRMED_COLLECT_PAYMENT_ACTION =
  "CONFIRMED_COLLECT_PAYMENT_ACTION";
export const CONFIRMED_UPCOMING_APPOINTMENT = "CONFIRMED_UPCOMING_APPOINTMENT";
export const CONFIRMED_GET_AVAILABLE_SLOTS = "CONFIRMED_GET_AVAILABLE_SLOTS";
export const CONFIRMED_RESCHEDULE_APPOINTMENT =
  "CONFIRMED_RESCHEDULE_APPOINTMENT";
export const CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT =
  "CONFIRMED_RESCHEDULE_QUEUE_APPOINTMENT";
export const CONFIRMED_SEND_FORM_LINK = "CONFIRMED_SEND_FORM_LINK";
export const CONFIRMED_PAUSE_DOCTOR_QUEUE = "CONFIRMED_PAUSE_DOCTOR_QUEUE";
export const CONFIRMED_MARK_PATIENT_EMERGENCY =
  "CONFIRMED_MARK_PATIENT_EMERGENCY";
export const CONFIRMED_MARK_PATIENT_COMPLETE =
  "CONFIRMED_MARK_PATIENT_COMPLETE";
export const CONFIRMED_GET_BOOKED_APPOINTMENTS =
  "CONFIRMED_GET_BOOKED_APPOINTMENTS";

export const FAILED_GET_BOOKED_APPOINTMENTS =
  "FAILED_GET_BOOKED_APPOINTMENTS";
export const CONFIRMED_RESCHEDULE_BOOKED_APPOINTMENT =
  "CONFIRMED_RESCHEDULE_BOOKED_APPOINTMENT";

export const FAILED_RESCHEDULE_BOOKED_APPOINTMENT =
  "FAILED_RESCHEDULE_BOOKED_APPOINTMENT";
  export const MARK_PATIENT_NEXT_REQUEST = "MARK_PATIENT_NEXT_REQUEST";
  export const MARK_PATIENT_NEXT_SUCCESS = "MARK_PATIENT_NEXT_SUCCESS";
  export const MARK_PATIENT_NEXT_FAILURE = "MARK_PATIENT_NEXT_FAILURE";
  export const CONFIRMED_SEND_REMINDER = "CONFIRMED_SEND_REMINDER";
  export const FAILED_SEND_REMINDER = "FAILED_SEND_REMINDER";
  export const CONFIRMED_GET_EMERGENCY_PATIENTS = "CONFIRMED_GET_EMERGENCY_PATIENTS";
export const FAILED_GET_EMERGENCY_PATIENTS = "FAILED_GET_EMERGENCY_PATIENTS";
export const CONFIRMED_ADD_BACK_TO_QUEUE = "CONFIRMED_ADD_BACK_TO_QUEUE";
export const FAILED_ADD_BACK_TO_QUEUE = "FAILED_ADD_BACK_TO_QUEUE";

export const CONFIRMED_UPLOAD_PATIENT_PHOTO =
  "CONFIRMED_UPLOAD_PATIENT_PHOTO";
  export const CONFIRMED_ADD_SEARCH_PATIENT_QUEUE =
  "CONFIRMED_ADD_SEARCH_PATIENT_QUEUE";

export const FAILED_ADD_SEARCH_PATIENT_QUEUE =
  "FAILED_ADD_SEARCH_PATIENT_QUEUE";